import { z } from "zod";

/** ID 一律为 UUID。 */
export const uuidSchema = z.uuid();

/** 时间统一为 ISO 8601 字符串，存储为 UTC。 */
export const isoDateTimeSchema = z.iso.datetime();

/** 金额一律为整数分，字段名以 Fen 结尾。 */
export const moneyFenSchema = z.int();

/** 业务尺寸一律为毫米，禁止使用像素或厘米。 */
export const millimeterSchema = z.number().finite();

/** 版本号一类必须为正整数的字段。 */
export const positiveIntSchema = z.int().positive();
